<!--
    Lovi
    2020-1-7 11:08:44
-->
<template>
  <div id="app" v-wechat-title="$t('common.pageTitle')">
    <common-header v-if="$route.meta.head"></common-header>
    <keep-alive :include="include">
      <router-view />
    </keep-alive>
    <!-- <keep-alive v-if="$route.meta.keepAlive">
      <router-view></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    <Spin fix size="large" v-if="loading"></Spin>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CommonHeader from "@/components/common/header";
export default {
  components: {
    CommonHeader
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("GET_PLATFORM_INFO");
    if (localStorage.getItem("token")) {
      this.$store.dispatch("GET_USER_INFO"); //刷新获取个人信息
    }
  },
  computed: {
    ...mapGetters(["loading", "include", "token"])
  },
  methods: {
    ...mapActions(["GET_PLATFORM_INFO"])
  },
  watch: {}
};
</script>

<style lang="less">
#app {
  position: relative;
  /deep/.ivu-spin-fix {
    position: fixed;
  }
}
</style>
